import { atom } from "recoil";

/**
 * 메뉴 타이틀
 */
export const menuTitleState = atom<string>({
  key: "menuTitle",
  default: "대시보드",
});
